import { PartialMessage } from '@bufbuild/protobuf'
import type { PageThemeSchema } from '@fingertip/creator-proto/gen/fingertip/common/type/v1/page_theme_schema_pb'
import { CSSProperties } from 'react'

import { MediaImage } from '../blocks/shared/media-image'

type Props = {
  content: PartialMessage<PageThemeSchema> | undefined
  style?: CSSProperties
}

export const PageBackground = ({ content, style }: Props) => {
  return (
    <MediaImage
      width={1000}
      height={1000}
      media={content?.media}
      style={{
        height: '100lvh',
        width: '100vw',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: -1,
        ...style,
      }}
    />
  )
}
